/* Copyright 2025 Supovia LLC */

// Server-side callers (another product's api Lambda, a script, a cron) hold a
// Supovia API key rather than an operator session. Mirrors the seam every other
// internal client in this monorepo exposes — @prosperanova/client/apiKey.js,
// @wapiworld/client/apiKey.js, @imagelato/client/apiKey.js — so a host product
// can authenticate without going through the login/refresh-token dance that the
// embedded widget uses.
//
// When set, http.js sends `Authorization: Basic base64(<secret>)`, which
// supovia/api's withKey.js authenticates. Leave unset in the browser: the key
// is a SERVER credential and must never reach a client bundle.
let apiKey = null

export function getApiKey() {
  return apiKey
}

export function setApiKey(apiKey_) {
  apiKey = apiKey_
}

export const setApiKeyForSupoviaClient = setApiKey
